import {
  AD_ANIMATION_TIME,
  AD_ANIMATION_DURATION,
  AD_PLACEMENT_ID,
  AD_ID,
  AD_STATE,
  AD_VIEWABLE_PERCENTAGE,
  AD_VIEWPORT_WIDTH,
  AD_VIEWPORT_HEIGHT,
  AD_UNIT_LEFT_POSITION,
  AD_UNIT_RIGHT_POSITION,
  AD_UNIT_TOP_POSITION,
  AD_UNIT_BOTTOM_POSITION,
  AD_PARENT_WINDOW_WIDTH,
  AD_PARENT_WINDOW_HEIGHT,
  SESSION_UUID,
  SESSION_TIME,
  AD_TIME_ISO,
  AD_TIME_OFFSET,
  DOC_WIDTH,
  DOC_HEIGHT,
  WNDW_WIDTH,
  WNDW_HEIGHT,
  DVCE_SCREENWIDTH,
  DVCE_SCREENHEIGHT,
  DOC_CHARSET,
  BR_LANG,
  AD_IS_MRAID,
  AD_IS_SAFEFRAME,
  AD_HOST,
  AD_URL,
  AD_PAGE_REFERRER,
  ORGANISATION_LINE_ITEM_ID,
  ORGANISATION_INVENTORY_ID,
  ORGANISATION_AUDIENCE_ID,
  ORGANISATION_AUDIENCE_SEGMENT_ID,
  ORGANISATION_AUDIENCE_CUSTOM,
} from 'Tracking/constants/trackingNames';

export const getDwell = (startTime = new Date()) => (new Date() - startTime);

export const toMilliseconds = (value = 0) => parseInt(value * 1000, 10);

// getThirdPartyDelivery
export const getOrganisationTracking = (state) => {
  const { organisationTracking } = state;
  const tracking = organisationTracking || {};
  return {
    [ORGANISATION_LINE_ITEM_ID]: tracking.organisationLineItemID || '',
    [ORGANISATION_INVENTORY_ID]: tracking.organisationInventoryID || '',
    [ORGANISATION_AUDIENCE_ID]: tracking.organisationAudienceId || '',
    [ORGANISATION_AUDIENCE_SEGMENT_ID]: tracking.organisationAudienceSegmentId || '',
    [ORGANISATION_AUDIENCE_CUSTOM]: tracking.organisationAudienceCustom || '',
  };
};

export const getTrackingFromTimeLine = (state) => {
  const {
    activeArtboard,
    timelines,
  } = state;
  if (typeof activeArtboard === 'undefined') {
    return {
      [AD_ANIMATION_TIME]: 0,
      [AD_ANIMATION_DURATION]: 0,
    };
  }
  const timeline = timelines[activeArtboard.key];
  return {
    [AD_ANIMATION_TIME]: toMilliseconds(timeline.time()),
    [AD_ANIMATION_DURATION]: toMilliseconds(timeline.duration()),
  };
};

export const getTrackingFromAdMetadata = (state) => {
  const {
    placementId,
    id: adId,
    activeArtboard = {},
    viewablePercentage = 0,
  } = state;
  const { name = '' } = activeArtboard;
  return {
    [AD_PLACEMENT_ID]: placementId,
    [AD_ID]: adId,
    [AD_STATE]: name,
    [AD_VIEWABLE_PERCENTAGE]: viewablePercentage,
  };
};

export const isIniFrameFunc = (win) => {
  try {
    return win.self !== win.top;
  } catch (e) {
    return true;
  }
};

export const canAdAccessIframe = (win) => {
  try {
    // this is due to IE and Windows, the .parentNode is for firefox
    return !!win.frameElement && !!win.frameElement.parentNode;
  } catch (e) {
    return false;
  }
};

const getTopMostAccessibleWindow = (win) => {
  try {
    let thisWindow = win;
    let windowParent = thisWindow.parent;
    while (
      thisWindow !== windowParent
      &&
      (
        thisWindow.innerWidth === windowParent.innerWidth
        && thisWindow.innerHeight === windowParent.innerHeight
      )
    ) {
      // incase served in an iframe inside an iframe
      thisWindow = windowParent;
      windowParent = windowParent.parent;
    }
    return windowParent;
  } catch (e) {
    return win.parent;
  }
};

const getSizeFromSafeFrame = (safeFrame) => {
  const geom = safeFrame.geom();
  const self = geom.self;
  const win = geom.win;

  return {
    [AD_VIEWPORT_WIDTH]: self.w,
    [AD_VIEWPORT_HEIGHT]: self.h,
    [AD_UNIT_LEFT_POSITION]: self.l,
    [AD_UNIT_RIGHT_POSITION]: self.r,
    [AD_UNIT_TOP_POSITION]: self.t,
    [AD_UNIT_BOTTOM_POSITION]: self.b,
    [AD_PARENT_WINDOW_WIDTH]: win.w,
    [AD_PARENT_WINDOW_HEIGHT]: win.h,
  };
};

const getSizeFromBrowser = (rootElement, rootDocument, rootWindow, isIframe, canAccessIframe) => {
  const parentWindow = isIframe && canAccessIframe
    ?
      getTopMostAccessibleWindow(rootWindow)
    :
      rootWindow;
  const rootDocumentElement = rootDocument.documentElement;
  const scrollLeft = (
    rootWindow.pageXOffset
    ||
    rootDocumentElement.scrollLeft) - (rootDocumentElement.clientLeft
    ||
    0
  );
  const scrollTop =
    (rootWindow.pageYOffset || rootDocumentElement.scrollTop)
    -
    (rootDocumentElement.clientTop || 0);
  const rootElementBoundingClientRect = rootElement.getBoundingClientRect();
  return {
    [AD_VIEWPORT_WIDTH]: (rootElementBoundingClientRect.width === null
      ? rootElement.offsetWidth
      : rootElementBoundingClientRect.width) || 0,
    [AD_VIEWPORT_HEIGHT]: (rootElementBoundingClientRect.height === null
      ? rootElement.offsetWidth
      : rootElementBoundingClientRect.height) || 0,
    [AD_UNIT_LEFT_POSITION]: rootElementBoundingClientRect.left + scrollLeft,
    [AD_UNIT_RIGHT_POSITION]: rootElementBoundingClientRect.right,
    [AD_UNIT_TOP_POSITION]: rootElementBoundingClientRect.top + scrollTop,
    [AD_UNIT_BOTTOM_POSITION]: rootElementBoundingClientRect.bottom,
    [AD_PARENT_WINDOW_WIDTH]: parentWindow.innerWidth,
    [AD_PARENT_WINDOW_HEIGHT]: parentWindow.innerHeight,
  };
};

export const getBaseTrackingFromAdMetadata = (placementId, adId) => ({
  [AD_PLACEMENT_ID]: placementId,
  [AD_ID]: adId,
});

export const getBaseTrackingFromClient = (tagInformation) => {
  const rootElement = tagInformation.element;
  const rootDocument = rootElement.ownerDocument;
  const body = rootDocument.body;
  const html = rootDocument.documentElement;
  const rootWindow = rootDocument.defaultView;
  const ivoScreen = rootWindow.screen;
  return {
    [SESSION_UUID]: tagInformation.sessionId,
    [DOC_WIDTH]: Math.max(body.scrollWidth, body.offsetWidth,
      html.clientWidth, html.scrollWidth, html.offsetWidth),
    [DOC_HEIGHT]: Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight),
    [WNDW_WIDTH]: rootWindow.innerWidth || html.clientWidth || body.clientWidth,
    [WNDW_HEIGHT]: rootWindow.innerHeight || html.clientHeight || body.clientHeight,
    [DVCE_SCREENWIDTH]: ivoScreen.width,
    [DVCE_SCREENHEIGHT]: ivoScreen.height,
    [DOC_CHARSET]: rootDocument.characterSet || rootDocument.charset,
  };
};

export const getTrackingFromClient = (state) => {
  const {
    rootElement,
    mraid = false,
    safeFrame = false,
    sessionId,
    sessionStartTime,
    rootDocument,
    rootWindow,
    href,
    referrer,
    url,
    isIframe,
    canAccessIframe,
  } = state;
  const tracking = {};
  const time = new Date();
  const body = rootDocument.body;
  const html = rootDocument.documentElement;
  const ivoScreen = rootWindow.screen;
  const ivoNavigator = rootWindow.navigator;

  const clientSize = safeFrame
    ?
      getSizeFromSafeFrame(safeFrame)
    :
      getSizeFromBrowser(rootElement, rootDocument, rootWindow, isIframe, canAccessIframe);

  return {
    ...tracking,
    ...clientSize,
    [SESSION_UUID]: sessionId,
    [SESSION_TIME]: time - sessionStartTime,
    [AD_TIME_ISO]: time.toISOString(),
    [AD_TIME_OFFSET]: time.getTimezoneOffset(),
    [DOC_WIDTH]: Math.max(body.scrollWidth, body.offsetWidth,
      html.clientWidth, html.scrollWidth, html.offsetWidth),
    [DOC_HEIGHT]: Math.max(body.scrollHeight, body.offsetHeight,
      html.clientHeight, html.scrollHeight, html.offsetHeight),
    [WNDW_WIDTH]: rootWindow.innerWidth || html.clientWidth || body.clientWidth,
    [WNDW_HEIGHT]: rootWindow.innerHeight || html.clientHeight || body.clientHeight,
    [DVCE_SCREENWIDTH]: ivoScreen.width,
    [DVCE_SCREENHEIGHT]: ivoScreen.height,
    [DOC_CHARSET]: rootDocument.characterSet || rootDocument.charset,
    [BR_LANG]: ((ivoNavigator.languages
      &&
        ivoNavigator.languages[0])
      || // Chrome / Firefox
        ivoNavigator.language
      || // All browsers
        ivoNavigator.userLanguage), // IE <= 10
    [AD_IS_MRAID]: !!mraid, // true false if mraid
    [AD_IS_SAFEFRAME]: !!safeFrame, // true false if safeframe
    [AD_HOST]: url,
    [AD_URL]: href,
    [AD_PAGE_REFERRER]: referrer,
  };
};



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/tracking/selectors/index.js